import React from "react";
import { finApi } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import { InvoiceRow } from "@/components/nds/windows/finance/InvoicesView";

export default function VendorInvoicesTab({ vendor, onOpenInvoice }) {
  const [state, load] = useLoad(() => finApi.get("/invoices", { vendor_id: vendor.id }), [vendor.id]);
  if (state.loading && !state.data) return <Loading testid="fin-vendor-invoices-loading" />;
  if (state.error) return <ErrorBox testid="fin-vendor-invoices-error" error={state.error} onRetry={load} />;
  if (!state.data.invoices.length) return <Empty testid="fin-vendor-invoices-empty">No invoices for this vendor yet.</Empty>;
  return (
    <ul data-testid="fin-vendor-invoices" className="divide-y divide-white/5">
      {state.data.invoices.map((inv) => <InvoiceRow key={inv.id} inv={inv} onOpen={onOpenInvoice} onChanged={load} />)}
    </ul>
  );
}
